<form [formGroup]="systemSettingsForm">
    @if (billingPolicies.usesCredits()) {
        <mat-card class="mb-3">
            <mat-card-header><mat-card-title><h2>Credits</h2></mat-card-title></mat-card-header>
            <mat-card-content>
                <div class="row" formGroupName="credits">
                    <mat-form-field class="col-12 col-md-4">
                        <input
                            type="number"
                            matInput
                            [ngClass]="{
                                'is-invalid': form.credits.get('low_credit_warning')
                                    .errors
                            }"
                            placeholder="Low Credit Reminder Trigger Level"
                            formControlName="low_credit_warning"
                        />
                        @if (form.credits.get('low_credit_warning').errors) {
                        <div class="invalid-feedback">
                            @if
                            (form.credits.get('low_credit_warning').errors?.required)
                            {
                            <div>
                                Low Credit Warning is required.
                            </div>
                            }
                        </div>
                        }
                        <span matSuffix>
                            <app-popover [popoverContent]="creditLevelPopover" label="About credit reminder levels">
                                <mat-icon fontIcon="help" aria-hidden="true"></mat-icon>
                            </app-popover>
                        </span>

                        <ng-template #creditLevelPopover>
                            <mat-card>
                                <mat-card-header>
                                    <mat-card-subtitle
                                        >Credit Reminder Level</mat-card-subtitle
                                    >
                                </mat-card-header>

                                <mat-card-content
                                    >Choose the threshold at which the system will
                                    remind you to top up your credit
                                    balance.</mat-card-content
                                >
                            </mat-card>
                        </ng-template>
                    </mat-form-field>

                    <div class="col-12" *appCan="'edit_settings'">
                        <button
                            mat-raised-button
                            color="primary"
                            type="button"
                            (click)="submitCredits()"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    }
    <mat-card class="mb-3" *appCan="'edit_settings'">
        <mat-card-header><mat-card-title><h2>Services</h2></mat-card-title></mat-card-header>
        <mat-card-content>
            <div class="row" formGroupName="services">
                <div class="col-12">
                    <p>Choose the services available for new work. Existing surveys and reports stay available.</p>
                    @for (service of services; track service.id) {
                        <mat-checkbox class="d-block" color="primary" [checked]="form.services.get('enabled_services').value.includes(service.id)" (change)="toggleService(service.id, $event.checked)" [disabled]="savingServices">{{ service.label }}</mat-checkbox>
                    }
                    @if (servicesSubmitted && form.services.invalid) { <p class="text-danger mt-2" role="alert">Choose at least one service.</p> }
                    @if (servicesError) { <p class="text-danger mt-2" role="alert">{{ servicesError }}</p> }
                    <button mat-raised-button color="primary" class="mt-3" type="button" (click)="submitServices()" [disabled]="savingServices">{{ savingServices ? 'Saving…' : 'Save' }}</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-card *appCan="'edit_settings'">
        <mat-card-header><mat-card-title><h2>Pricing</h2></mat-card-title></mat-card-header>
        <mat-card-content>
            <div class="row" formGroupName="pricing">
                <div class="col-12">
                    <p class="mb-3">Add product rates and track costs across your surveys. Hide pricing if you only need inspections and reports. This won’t affect your subscription or credits.</p>
                    <mat-slide-toggle color="primary" formControlName="pricing_enabled">Enable pricing features</mat-slide-toggle>
                </div>

                <div class="col-12 mt-3">
                    <button mat-raised-button color="primary" type="button" (click)="submitPricing()">
                        Save
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</form>
